import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ContatoMensagem } from '../models/contato-mensagem.model';
import { Banner } from '../models/banner.model';
import { Fato } from '../models/fato.model';
import { Sobre } from '../models/sobre.model';
import { ContatoGeral } from '../models/contato-geral.model';
import { CadastroGeral } from '../models/cadastro-geral.model';
import {
  daApi, listaDaApi, paraApi, parametrosLista,
  MAP_BANNER, MAP_BENEFICIO, MAP_CADASTRO_GERAL, MAP_CONTATO_GERAL,
  MAP_CURSO, MAP_DEPOIMENTO, MAP_FATO, MAP_MENSAGEM, MAP_NOTICIA, MAP_SOBRE
} from './api-map';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor(
    public api: ApiService
  ) { }

  // Os registros unicos sao lidos direto nos templates (contatoGeral.whatsApp,
  // sobre.descricao, ...), entao nunca podem voltar nulos.
  buscarContatoGeral(): Observable<any> {
    return this.api.get('/contact').pipe(map((res: any) => res ? daApi(res, MAP_CONTATO_GERAL) : new ContatoGeral()));
  }

  buscarCadastroGeral(): Observable<any> {
    return this.api.get('/general-register').pipe(map((res: any) => res ? daApi(res, MAP_CADASTRO_GERAL) : new CadastroGeral()));
  }

  buscarSobre(): Observable<any> {
    // as telas usam sobre.descricao direto, entao nunca pode voltar nulo
    return this.api.get('/about').pipe(map((res: any) => res ? daApi(res, MAP_SOBRE) : new Sobre()));
  }

  // Na API nova o banner virou lista; o site mostra um so.
  buscarBanner(): Observable<any> {
    return this.api.get('/banner?page=1&count=1').pipe(
      map((res: any) => (res && res.data && res.data[0]) ? daApi(res.data[0], MAP_BANNER) : new Banner())
    );
  }

  buscarFatos(): Observable<any> {
    return this.api.get('/fact').pipe(map((res: any) => res ? daApi(res, MAP_FATO) : new Fato()));
  }

  buscarBeneficios(numeroPagina: number, registroPorPagina: number): Observable<any> {
    const query = parametrosLista(numeroPagina, registroPorPagina, { coluna: 'order', direcao: 'asc' });
    return this.api.get('/benefit' + query).pipe(map((res: any) => listaDaApi(res, MAP_BENEFICIO)));
  }

  buscarDepoimentos(numeroPagina: number, registroPorPagina: number): Observable<any> {
    const query = parametrosLista(numeroPagina, registroPorPagina, { coluna: 'date', direcao: 'desc' });
    return this.api.get('/testimonial' + query).pipe(map((res: any) => listaDaApi(res, MAP_DEPOIMENTO)));
  }

  buscarCursos(numeroPagina: number, registroPorPagina: number, tag: string = '%'): Observable<any> {
    const query = parametrosLista(numeroPagina, registroPorPagina, { coluna: 'name', direcao: 'asc' }, tag);
    return this.api.get('/course' + query).pipe(map((res: any) => listaDaApi(res, MAP_CURSO)));
  }

  buscarUltimasCursos(numeroPagina: number, registrosPorPagina: number, idCurso: any, tag: string = '%'): Observable<any> {
    const query = parametrosLista(numeroPagina, registrosPorPagina, { coluna: 'name', direcao: 'asc' }, tag, idCurso);
    return this.api.get('/course' + query).pipe(map((res: any) => listaDaApi(res, MAP_CURSO)));
  }

  buscarCurso(slug: string): Observable<any> {
    return this.api.get(`/course/slug/${slug}`).pipe(map((res: any) => daApi(res, MAP_CURSO)));
  }

  buscarTagsCurso(): Observable<any> {
    return this.api.get('/course/tags');
  }

  buscarNoticias(numeroPagina: number, registroPorPagina: number, tag: string = '%'): Observable<any> {
    const query = parametrosLista(numeroPagina, registroPorPagina, { coluna: 'date', direcao: 'desc' }, tag);
    return this.api.get('/news' + query).pipe(map((res: any) => listaDaApi(res, MAP_NOTICIA)));
  }

  buscarNoticia(slug: string): Observable<any> {
    return this.api.get(`/news/slug/${slug}`).pipe(map((res: any) => daApi(res, MAP_NOTICIA)));
  }

  inserirMensagem(msg: ContatoMensagem): Observable<any> {
    const corpo = paraApi(msg, MAP_MENSAGEM);

    // subject e type sao obrigatorios na API e o formulario do site nao tem esses campos
    corpo.subject = corpo.subject || 'Contato pelo site';
    corpo.type = corpo.type || 'contato';

    return this.api.post('/message', corpo);
  }

  buscarUltimasNoticias(numeroPagina: number, registrosPorPagina: number, idNoticia: any, tag: string = '%'): Observable<any> {
    const query = parametrosLista(numeroPagina, registrosPorPagina, { coluna: 'date', direcao: 'desc' }, tag, idNoticia);
    return this.api.get('/news' + query).pipe(map((res: any) => listaDaApi(res, MAP_NOTICIA)));
  }

  buscarTagsNoticia(): Observable<any> {
    return this.api.get('/news/tags');
  }

}
